module.exports = __webpack_public_path__ + "bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/bf.svg
// module id = 444
// module chunks = 0